import { render, staticRenderFns } from "./Redemption.vue?vue&type=template&id=4be189e6&scoped=true&"
import script from "./Redemption.vue?vue&type=script&lang=ts&"
export * from "./Redemption.vue?vue&type=script&lang=ts&"
import style0 from "./Redemption.vue?vue&type=style&index=0&id=4be189e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be189e6",
  null
  
)

export default component.exports